// extracted by mini-css-extract-plugin
module.exports = {"baseList":"BaseList_baseList_ViA2A","isStyleInfo":"BaseList_isStyleInfo_15JSp","isStyleBill":"BaseList_isStyleBill_2P5cD","isStyleOrder":"BaseList_isStyleOrder_1IJiQ"};